import { Formatter } from '../../../../core/types/formatter.js';
import { safeGet } from '../../../providers/HistogramDataProvider.js';
import { HistogramBin, WeakMapBins } from '../../../types/histogram.js';

/**
 * Get a formatted text to the Tooltip header
 * @param binsMap - A Weakmap of bins metadata
 * @param bin - The Histogram bin data set
 * @param formatter - The formatter to return a string based an raw bin data
 * @param preposition - The internationalized proposition to be interpolated
 * @returns A interpolated string to be shown in the tooltip header
 **/
export const getHeaderLabel = (
  binsMap: WeakMapBins,
  bin: HistogramBin,
  formatter: Formatter,
  preposition: string,
) => {
  const { from, to } = safeGet(binsMap, bin);

  return `${formatter(from)} ${preposition} ${formatter(to)}`;
};
